import { YoutubeLinkRepository } from '../../domain/repositories/youtube-link.repository.js';
import { YoutubeLinkEntity, YoutubeLinkProps } from '../../domain/entities/youtube-link.entity.js';

export type CreateYoutubeLinkInput = Omit<YoutubeLinkProps, 'id' | 'createdAt' | 'updatedAt' | 'videoId' | 'thumbnailUrl'>;

export class CreateYoutubeLinkUseCase {
  constructor(private readonly repository: YoutubeLinkRepository) {}

  public async execute(input: CreateYoutubeLinkInput): Promise<YoutubeLinkEntity> {
    return this.repository.create(input);
  }
}
